<template>
	<el-main>
		<el-row>
			<el-col :lg="4" :xl="4">
				<div class="hidden-md-and-down">&nbsp;</div>
			</el-col>
			<el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
				<div class="more-body hidden-md-and-down">
					<SideMenu :data="sideMenu" />
					<div style="margin-left: 240px;">
						<!-- <keep-alive> -->
						<router-view />
						<!-- </keep-alive> -->
					</div>
				</div>
				<div class="more-m hidden-lg-and-up">
					<el-collapse v-model="activeName" accordion>
						<el-collapse-item :title="sideMenu[0].title" name="1">
							<Introduction />
						</el-collapse-item>
            <el-collapse-item :title="sideMenu[1].title" name="2">
              <Progress />
            </el-collapse-item>
						<el-collapse-item :title="sideMenu[2].title" name="3">
							<Terms />
						</el-collapse-item>
						<el-collapse-item :title="sideMenu[3].title" name="4">
							<Privacy />
						</el-collapse-item>
						<el-collapse-item :title="sideMenu[4].title" name="5">
							<JoinUs />
						</el-collapse-item>
						<el-collapse-item :title="sideMenu[5].title" name="6">
							<ContactUs />
						</el-collapse-item>
					</el-collapse>
				</div>
			</el-col>
			<el-col :lg="4" :xl="4">
				<div class="hidden-md-and-down">&nbsp;</div>
			</el-col>
		</el-row>
	</el-main>
</template>

<script>
	import SideMenu from './SideMenu'
	import Introduction from './Introduction'
	import Terms from './Terms'
	import Privacy from './Privacy'
	import Progress from './Progress'
	import JoinUs from './JoinUs'
	import ContactUs from './ContactUs'
	export default {
		name: 'More',
		components: {
			SideMenu,
			Introduction,
			Terms,
			Privacy,
			Progress,
			JoinUs,
			ContactUs
		},
		data() {
			return {
				sideMenu: [{
					id: 0,
					title: '公司介绍',
					url: '/more/introduction',
				}, {
          id: 1,
          title: '发展历程',
          url: '/more/progress'
        },{
					id: 2,
					title: '服务条款',
					url: '/more/terms-of-service'
				}, {
					id: 3,
					title: '隐私声明',
					url: '/more/privacy-policy'
				},  {
					id: 4,
					title: '加入我们',
					url: '/more/join-us'
				}, {
					id: 5,
					title: '联系我们',
					url: '/more/contact-us'
				}],
				activeName: 1
			}
		},
    mounted() {
    },
    activated() {
      console.log("===== more activated =====");
      if(this.$route.query.activeName) {
        console.log("===== more activated =====", this.$route.query.activeName);
        this.activeName = this.$route.query.activeName+'';
      }
    }
  }
</script>

<style>
	@media (max-width:992px) {
		.more-m {
      margin-top: 8vw;
			margin-bottom: 111px;
			width: 100%;
			display: flex;
			justify-content: center;
		}

		.more-m .el-collapse {
			width: 90%;
		}

		.more-m .el-collapse-item__content {
			background-color: #FFFFFF;
		}
	}

	@media (min-width:992px) {
		.more-body {
			margin: 118px 0 161px;
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			width: 100%;
		}


	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/More.vue